import React from 'react'
import "./FooterNew.css"

function FooterNew() {
  return (
    <div className='FooterNew-container standard-padding-space pb-0'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-4'>
              <div className='text-start'>
                <h2 className="body-heading color-light" style={{fontWeight:"600",fontSize:"3rem",letterSpacing:"10px",textTransform:"uppercase"}}>Divitiis</h2>
                <p className='body-paragraph color-light'>Dare to Be You. Tell It Boldly.</p>
              </div>
            </div>

            <div className='col-lg-4 '>
                {/* <h3 className='color-light body-heading pt-3' style={{fontSize:"1.6rem"}}>Social Links</h3> */}

                <div className='d-flex align-items-center gap-3 pt-3 justify-content-center w-100 d-none'>
                  {/* <img src='/images/icons/fb-icon.png' alt='icon' style={{cursor:"pointer"}}/> */}
                  <a href="https://www.instagram.com/divitiisbybc?igsh=dTZkaGJsdDk3cnoy" target='blank'><img src='/images/icons/insta-icon.png' alt='icon' style={{cursor:"pointer"}} /></a>
                  <a href="https://www.linkedin.com/company/divitiisbybc" target='blank'><img src='/images/icons/li-icon.png' alt='icon' style={{cursor:"pointer"}}/></a>

                </div>
            </div>

            <div className='col-lg-4'>
                <h3 className='color-light body-heading pt-3' style={{fontSize:"1.6rem"}}>Contact Information</h3>
                <p className='color-light body-paragraph mt-4' style={{cursor:"pointer"}} onClick={()=>{window.open("mailto:betsycorreia@divitiisbc.com")}}>betsycorreia@divitiisbc.com</p>
                <div className='d-flex align-items-center gap-3 pt-3 justify-content-start w-100'>
                  <a href="https://www.instagram.com/divitiisbybc?igsh=dTZkaGJsdDk3cnoy" target='blank'><img src='/images/icons/insta-icon.png' alt='icon' style={{cursor:"pointer"}} /></a>
                  <a href="https://www.linkedin.com/company/divitiisbybc" target='blank'><img src='/images/icons/li-icon.png' alt='icon' style={{cursor:"pointer"}}/></a>

                </div>
            </div>

            <div className='col-lg-12 pt-5 d-flex align-items-center  text-center flex-lg-row flex-column justify-content-center'>

              {/* <p className='color-light'>Made With ❤️ By <span onClick={()=>{window.open("https://www.creativesquad.ca/")}}>Creative Squad</span></p> */}
              <p className='color-light'>2025 Divittis,  All Rights Reserved</p>
            </div>

          </div>
          

        </div>
    </div>
  )
}

export default FooterNew